import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalAddEditProtestoComponent } from '../modal-add-edit-protesto/modal-add-edit-protesto.component';

@Component({
  selector: 'app-cheques-protesto-cabecera',
  templateUrl: './cabecera.component.html',
  styleUrls: ['./cabecera.component.scss']
})
export class CabeceraComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalAddEditProtestoComponent, { static: true }) modalProtesto: ModalAddEditProtestoComponent
  @Output() onClienteChange: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formHeader: FormGroup

  // Outputs
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>()
  @Output() onSearchAll: EventEmitter<void> = new EventEmitter()

  // Data &  Tmp
  clienteSeleccionado: any = null
  filtersDisabled: boolean = false
  headerData: any = {}
  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('REVERSO-PAGOS-CABECERA')
  }

  ngOnInit() {
    this.createForm()
    this.formChangesSubscriptions()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      rutCliente: [null],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
        this.modalSeleccionarCliente.cleanLast()
      })
  }

  openModalProtesto() {
    this.modalProtesto.show()
  }

  openModalSeleccionarClientes() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data
    this.formHeader.get('rutCliente').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut))
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
    this.clearClientData()
  }
  clearClientData() {
    this.clearContent()
    this.onClienteChange.emit(null)
  }
  clearContent(){
    this.headerData = {}
    this.formValidatorsService.reset(this.formHeader)
  }

  handleCheckTodos({ checked }) {
    this.log('handleCheckTodos', checked)
    this.filtersDisabled = checked
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()
    // if (checked) {
    //   this.clearForm()
    // }
  }

  clearForm() {
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()
    this.clienteSeleccionado = null
    this.formHeader.get('rutCliente').setValue(null)
    this.formHeader.get('fechaDesde').setValue(null)
    this.formHeader.get('fechaHasta').setValue(null)
  }

  buscar() {
    if (this.filtersDisabled) {
      this.onSearchAll.emit()
      return
    }

    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.onSearch.emit(this.formHeader.value)
  }

}
